import { render, staticRenderFns } from "./OrderVersionsTable.vue?vue&type=template&id=d83710f8&scoped=true"
import script from "./OrderVersionsTable.vue?vue&type=script&lang=js"
export * from "./OrderVersionsTable.vue?vue&type=script&lang=js"
import style0 from "./OrderVersionsTable.vue?vue&type=style&index=0&id=d83710f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83710f8",
  null
  
)

export default component.exports